import { render, staticRenderFns } from "./NumericCounterInput.vue?vue&type=template&id=2b5fdf30&scoped=true&"
import script from "./NumericCounterInput.vue?vue&type=script&lang=js&"
export * from "./NumericCounterInput.vue?vue&type=script&lang=js&"
import style0 from "./NumericCounterInput.vue?vue&type=style&index=0&id=2b5fdf30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5fdf30",
  null
  
)

export default component.exports